export default __webpack_public_path__ + "static/media/screen2.6d4aa68a.png";